import React from 'react';
import ReactDOM from 'react-dom';
import LoggedInPage from '../../views/core/LoggedInPage';
import Iframe from 'react-iframe';
import $ from 'jquery';
import '../../css/GetTest.css';
import HmAjax from '../../util/HmAjax';
import Pagination from 'react-ultimate-pagination-material-ui';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import CircularProgressbar from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import HmEventRegistry from '../../model/HmEventRegistry';



class GetTest extends LoggedInPage {
	
	constructor(props) {
		super(props);
		this.displayTextObj = {};
		this.displayTextObj.solutionTitle = this.rb("editor.solutionTitle");
		this.displayTextObj.answerTitleSingle = "";
		this.displayTextObj.answerTitlePlural = "";
		this.displayTextObj.showEditorTooltip = this.rb("editor.showEditorTooltip");
		this.displayTextObj.hideEditorTooltip = this.rb("editor.hideEditorTooltip");
		this.displayTextObj.enterAnswerMessage = this.rb("editor.enterAnswerMessage");

	//var iframeContentUrl = this.getUrlFor("IFRAME_DOMAIN") + "/prassoapp/20171102/";
    //console.log(this.props.topicInfoObj);
	//console.log("currentQNo="+this.props.topicInfoObj.userTest.currentQNo);
	this.testCompleted = false;
	this.showSolution = false;

	this.state = {
		pageCurrent: (this.props.topicInfoObj.testDetails.mode==1) ? 1 : this.props.topicInfoObj.userTest.currentAttempt,
		currentAttempt: (this.props.topicInfoObj.testDetails.mode==1) ? 1 : this.props.topicInfoObj.userTest.currentAttempt,
		currentQuesNo:(this.props.topicInfoObj.testDetails.mode==1) ? 1 : this.props.topicInfoObj.userTest.currentQNo,
		pageTotal: this.props.topicInfoObj.testDetails.questionCount,
		totalQuestions:this.props.topicInfoObj.testDetails.questionCount,
		paginationDisabled:false,
		percentageComplete:0,
		testMode:this.props.topicInfoObj.testDetails.mode,
		questionObj:[],
		questionRendered:false,
		attemptedQuestions:this.props.topicInfoObj.attempts || new Object(),
		questionEvaluated:false,
		showSolution:this.showSolution,
		testCompleted:this.testCompleted
	};

	this.onPageChange = this.onPageChange.bind(this);

	this.handleMessage = this.handleMessage.bind(this);
	this.iframeLoaded = this.iframeLoaded.bind(this);
	this.getQuestion = this.getQuestion.bind(this);
	this.modalCloseEvent = this.modalCloseEvent.bind(this);
	this.submitClick = this.submitClick.bind(this);
	this.EvaluateClick = this.EvaluateClick.bind(this);
	this.NextClick = this.NextClick.bind(this);
	this.viewHideSolutionClick = this.viewHideSolutionClick.bind(this);
	this.submitPractice = this.submitPractice.bind(this);
	this.enableQuestionTrackTimer = false;
	this.intervalId = null;
	this.checkImageLoaded = this.checkImageLoaded.bind(this);
	this.trackTestClose = this.trackTestClose.bind(this);
	
	this.forceSubmit = false;
	this.attemptBeforeEvaluate = null;

	this.prassoView = null;
	this.isPrassoViewLoaded = false;
	this.evalAndNavigate = false;
	this.evalAndSubmit = false;
	this.isSubmitTriggered = false;
	this.submittedQnMap = new Object();

	this.correctAns = false;
	this.solutionResults = [];
	this.attemptsLeft;
	this.allowedAttempts;
	this.currentAttempt;
	this.currentQuestionNo=0;
	this.totalCorrectAns;
	this.totalNoQuestions=0;
	
	this.isEvaluationGoing = false;
	this.currTestQuestionId = null;
	this.currentSnippetId = null;
	this.questionAnswerStartTime = null;
	this.questionAnswerElapsedTime = null;
	this.timeSpentAction="";
	this.currentRating = null;

	
	this.iframeContentDomain = null;//"http://local.retailmath.com:3000/";
	//const UltimatePagination = reactUltimatePaginationBasic.default;  	

	this.trackingQuestionObj = {};
	this.questionLoadTime = null;
}

  /*
  * IMPORTANT: This is for the very last question attempted by the user.
  * Auto-submission will still work from TimerComp irrespective of the configuration window.auto_submit_types - FOR NOW
  */
  isAutoSubmitAllowed(){
  	try{
  		let testType = this.props.topicInfoObj.testDetails.type;

  		if(window.auto_submit_types && window.auto_submit_types.length > 0){
  			return (~window.auto_submit_types.indexOf(testType)) ? true:false;
  		}
  	}catch(e){
  		console.error(e);
  	}

  	return false;
  }

  getCurrentQuestionNo(){
  	return this.currentQuestionNo;
  }

  getTotalQuestions(){
  	return this.totalNoQuestions;
  }

  forceSubmitMode(testMode){
  	if(!isNaN(testMode) && window.force_submit_test_mode){
  		return ~window.force_submit_test_mode.indexOf(testMode) ? true: false;
  	}

  	return false;
  }

  onCloseHandler(){
  	if(!this.isAjaxSubmitTriggered && (this.forceSubmitMode(this.state.testMode) || this.isAutoSubmitAllowed()) && this.getCurrentQuestionNo() > this.getTotalQuestions()){	
  		this.completeTest();
  	}else{
  		//this.triggerGetUserAnswer();
  		console.warn("This test is not eligible for submit on close.");
  	}
  }

  onPageChange(page) {  
  	this.setState({pageCurrent:page,paginationDisabled:true});      
    //this.getQuestion();
    this.timeSpentAction = "Pagination";
    this.evalAndNavigate = true;
    this.evalAndSubmit = false;
    this.evalAns();
} 
evalAns(){
	this.showSolution = false;
	this.correctAns = false;
	this.solutionResults = undefined;
	this.setState({showSolution:false});
	this.prassoView.postMessage({name:"getUserAnswer"}, this.iframeContentDomain);
}
iframeLoaded(){	   
	if(!this.container){
		this.container = document.getElementById("quesIframe");
	}

	const iframeDOMNode = ReactDOM.findDOMNode(this.container)
	this.prassoView = iframeDOMNode.contentWindow;

	this.isPrassoViewLoaded = true;
	if(this.prassoView){    	
		this.isAjaxSubmitTriggered = false;
		this.prassoView.postMessage({name:"setDisplayText",params:[this.displayTextObj]}, this.iframeContentDomain);
		if(this.state.testMode == 1){	
				//this.prassoView.enableTestMode();
				this.prassoView.postMessage({name:"enableTestMode"}, this.iframeContentDomain);
			}
		}


		if(this.state.testMode == 1){
			this.getQuestion();	
		}
		else{
			//console.log(this.currentQuestionNo,this.totalNoQuestions);
			if (this.currentQuestionNo > this.totalNoQuestions) {
				this.setState({testCompleted:true});
				this.completeTest(true);
			} else {
				this.getQuestion();	  
			}
		}
	}
	componentDidMount(){		
		this.questionAnswerStartTime = null;
		this.questionAnswerElapsedTime = null;
		this.enableQuestionTrackTimer = false;
		clearInterval(this.intervalId);
		this.initiateQuestionPulseTimer();
		this.currentRating = null;
		this.props.onRef(this);
	   //console.log(this.props.topicInfoObj);
	   this.currentAttempt = (this.props.topicInfoObj.testDetails.mode==1) ? 1 : this.props.topicInfoObj.userTest.currentAttempt;
	   this.currentQuestionNo = (this.props.topicInfoObj.testDetails.mode==1) ? 1 : this.props.topicInfoObj.userTest.currentQNo;
	   this.totalCorrectAns = this.props.topicInfoObj.userTest.totalCorrectAns || 0;
	   this.totalNoQuestions = this.props.topicInfoObj.userTest.ques.length || 0;
	   this.attemptsLeft = -1;
	   
	   if(this.state.attemptedQuestions){
	   	this.submittedQnMap = this.state.attemptedQuestions;
	   }
	   this.iframeContentDomain = this.getUrlFor("IFRAME_DOMAIN");
	   
	   window.addEventListener('message', this.handleMessage, false);
	   
	   if(!this.container){
	   	this.container = document.getElementById("quesIframe");
	   }

	   let iframeDOMNode = ReactDOM.findDOMNode(this.container);
	   
	   iframeDOMNode.addEventListener('load', this.iframeLoaded);
	   
	   HmEventRegistry.fireEvent("INITIATE_GA_EVENT");  
	}
	compoenentWillMount(){
		this.props.onRef(undefined);
		window.removeEventListener('message', this.handleMessage, false);
	}
	initiateQuestionPulseTimer(){
		var me = this;
		this.intervalId = setInterval(() => {
			if(me.enableQuestionTrackTimer){	   	 		
				me.trackQuestionPulsed();
			}
		}, 30000);
	}
	trackQuestionPulsed(){
		try{
			var trackObj = {
				"test_id": this.props.topicInfoObj.testDetails.id,
				"snippet_id": this.currentSnippetId,
				"question_source":this.state.questionObj.questionSource,
				"attempt_no": this.attemptBeforeEvaluate
			}
			this.initiateTrack("question_pulsed",trackObj);
		}catch(e){
		}
	}
	handleMessage(event){	
		console.log(event.origin+", "+this.iframeContentDomain);
	  /*if (event.origin !== this.iframeContentDomain) {
	    console.warn('Invalid origin:', event.origin);
	    return;
	}*/

	switch (event.data.name) {
		case 'renderingCompleted':
		this.setState({questionRendered:true,paginationDisabled:false});

		var endTime = new Date().getTime();
		var questionloadedTime = -1;
		if(this.questionLoadTime != null){
			questionloadedTime = endTime - this.questionLoadTime;
		}

		var trackingdummyObj = {};
		if(this.trackingQuestionObj !== undefined && typeof this.trackingQuestionObj === "object"){
			for(var key in this.trackingQuestionObj){
				trackingdummyObj[key] = this.trackingQuestionObj[key];
			}
		}

		trackingdummyObj["load_duration"] = questionloadedTime;		

		this.initiateTrack("question_loaded",trackingdummyObj);
		this.questionLoadTime = null;
		questionloadedTime = null;


		if(this.questionAnswerStartTime == null){
			this.questionAnswerStartTime = new Date().getTime();
		}

		this.enableQuestionTrackTimer = true;	    	

		if(typeof this.props.resumeTimer === "function"){
			this.props.resumeTimer();
		}
		break;
		case 'userAnswer':
		this.handleUserAnswer(JSON.parse(event.data.params));
		break;
	    case 'pushedUserAnswer':  // enterkey event    	
	    if(this.state.testMode == 1){
	    		//if($("#evaluateBtn").hasClass("disabled")===false){	    			
	    			this.evalAndNavigate = false;
	    			this.evalAndSubmit = false;
	    			this.timeSpentAction = "Check";
	    			this.handleUserAnswer(JSON.parse(event.data.params));
	    		//}
	    	}else{
	    		if(this.state.questionEvaluated == false && this.isEvaluationGoing == false){	    			
	    			this.evalAndNavigate = false;
	    			this.evalAndSubmit = false;
	    			this.timeSpentAction = "Check";
	    			this.isEvaluationGoing = true;
	    			this.handleUserAnswer(JSON.parse(event.data.params));
	    		}
	    	}  
	    	break;
	    }
	}
	handleUserAnswer(userAnswer) {		 
		var me = this;
		var userAnswered = userAnswer.userAnswered;
		var userResponse =  userAnswer.userResponse;
		
		var topicInfoObj = this.props.topicInfoObj.userTest.ques[this.state.currentQuesNo-1];
		var testid = this.props.topicInfoObj.testDetails.id;
		var quesType = this.state.questionObj.questionType;
		var currrentAttempt = this.state.currentAttempt;
		var mcqRes = null;
		var fibRes = null;
		
		if(quesType === "mcq"){
			mcqRes = userResponse;
		}else{
			fibRes = userResponse;
		}
		
		me.setState({paginationDisabled:false});
		
		if(userAnswered === false){		
			if(me.state.testMode == 1){			
				
				if(this.evalAndSubmit){
					this.isEvaluationGoing = false;
					me.trackTimeSpentInQuestion();
					me.completeTest();
					return;
				}
				
				if(userAnswer.partialAnswer){						
					this.isSubmitTriggered = false;
					this.evalAndNavigate = false;
					this.evalAndSubmit = false;
					this.isEvaluationGoing = false;
					return;
				}
				
			}else if(me.state.testMode == 2 && this.evalAndSubmit){
				me.trackTimeSpentInQuestion();
				this.isEvaluationGoing = false;
				me.completeTest();
				return;
			}
		}
		
		if(userAnswered === false  && me.state.testMode != 1){
			me.prassoView.focus();
			this.isEvaluationGoing = false;
			return;
		}else{
			if(me.state.testMode != 1){
				if(me.state.questionObj.questionType == "mcq"){				
					if (!userResponse.isUserOptionCorrect) {
						me.chooseShowSolution(false,false,this.solutionResults);
						me.ShowHideSolution();
					}
					else{										
						me.chooseShowSolution(false,false,this.solutionResults);
						me.ShowHideSolution();
					}
				}
			}
		}
		//console.log(userAnswered,userResponse);
		var callBackSuccess = function(response){
			var data = response;
			var finalResult = true;
			this.isEvaluationGoing = false;
			var solutionResults = new Object();
			for(var res in data){
				finalResult = finalResult & data[res];
				solutionResults[res] = data[res];
			}
			
			if(me.state.questionObj.questionType == "fib"){	
				this.showSolution = false;
				this.correctAns = false;	
				me.setState({showSolution:false});
				me.chooseShowSolution(this.correctAns,this.showSolution,solutionResults);
				if(this.showSolution){
					if(me.state.testMode != 1){
						me.setScrollElement("answers-display");
					}
				}				
			}
			
			try{
				var trackingdummyObj = {};
				if(this.trackingQuestionObj !== undefined && typeof this.trackingQuestionObj === "object"){
					for(var key in this.trackingQuestionObj){
						trackingdummyObj[key] = this.trackingQuestionObj[key];
					}
				}

				trackingdummyObj["result"] = finalResult;
				trackingdummyObj["answered"] = (userAnswered === undefined) ? true : userAnswered;
				me.initiateTrack("question_evaluated",trackingdummyObj);
			}catch(e){}
			
			me.postEvaluation(finalResult, userAnswered);
			
		}
		var callBackFailure = function(response){		
			this.isEvaluationGoing = false;
			console.log("QUESTION_EVALUATE Error : ", response);
			//me.setState({  modalContent:me.setTestScreen() });
		}
		this.trackTimeSpentInQuestion();
		var postParams={
			"snippetId":this.state.questionObj.snippetId,
			"testId":testid,
			"questionId":topicInfoObj.id,
			"questionType":quesType,
			"fibResponse":fibRes,
			"mcqResponse":mcqRes,
			"attemptNumber":currrentAttempt,
			"questionNumber":topicInfoObj.qOrder,
			"questionSource":topicInfoObj.source,
			"mode":me.state.testMode
		}

		if(typeof me.props.callbackParent === "function"){
			postParams["time"] = window.btoa(me.props.callbackParent());
			console.log("QUESTION_EVALUATE ",me.props.callbackParent());
		}
		
		new HmAjax(this.getUrlFor("QUESTION_EVALUATE"),postParams).put(callBackSuccess,callBackFailure);

		if(typeof this.props.pauseTimer === "function"){
			this.props.pauseTimer();
		}
	}
	postEvaluation(finalResult, userAnswered){
		var me = this;
		var topicInfoObj = this.props.topicInfoObj.userTest.ques[this.state.currentQuesNo-1];
		var currrentAttempt = this.state.currentAttempt;		
		me.setState({questionEvaluated:true});
		if(me.state.testMode == 1){	
			this.currentQuestionNo = me.state.pageCurrent;
			me.setState({currentQuesNo:me.state.pageCurrent});
			if(userAnswered == false || userAnswered == "" ){
				delete this.submittedQnMap[topicInfoObj.id+"-"+currrentAttempt];
				me.setState({attemptedQuestions:this.submittedQnMap});	
				
			}else{
				this.submittedQnMap[topicInfoObj.id+"-"+currrentAttempt]=true;
				me.setState({attemptedQuestions:this.submittedQnMap});					
			}
			
			if(me.forceSubmit){
				this.evalAndSubmit = true;
				me.completeTest();
			}else if(this.isSubmitTriggered){
				me.showSubmitConfirm();
				this.isSubmitTriggered = false;			
			}else{
				if(this.evalAndNavigate){
					me.getQuestion();
				}
				else if(this.evalAndSubmit){
					me.completeTest();
				}
			}
			
			
		}else{
			
			if(finalResult == true){
				this.attemptsLeft = -1;
				this.currentAttempt = 1;
				this.currentQuestionNo++;
				this.totalCorrectAns++;	
			}else{
				if (this.allowedAttempts < 1) {						
					this.currentAttempt++;
				} else {				
					this.attemptsLeft--;
					this.currentAttempt++;
					if (this.attemptsLeft > 0) {
						//$("#attemptsLeft").html(attemptsLeft.toString());
					} else if (this.attemptsLeft < 0) {
						this.attemptsLeft = -1;
						this.currentAttempt = 1;
						this.currentQuestionNo++;
					} else {
						//$("#attemptsLeft").html("-");
						this.attemptsLeft = -1;
						this.currentAttempt = 1;
						this.currentQuestionNo++;
					}
				}	
			}
			me.setState({currentAttempt:this.currentAttempt});
			console.log(this.currentQuestionNo,this.attemptsLeft,this.currentAttempt);
			if (this.currentQuestionNo > this.totalNoQuestions) {		
				me.setState({testCompleted:true});
				me.updateProgress();
				if(this.isAutoSubmitAllowed()){
					me.completeTest();
				}				
				return;
			}
		}		
		me.updateProgress();
	}
	chooseShowSolution(correctAns,showsolution,resultsObj){
		var me = this;
		if(me.state.testMode != 1){
			
			if(me.state.questionObj.questionType == "fib"){
				//this.prassoView.showSolution(false,showsolution,resultsObj);
				me.prassoView.postMessage({name:"showSolution",params:[false,showsolution,resultsObj]}, this.iframeContentDomain);
			}else{
				//this.prassoView.showSolution(false,showsolution);
				me.prassoView.postMessage({name:"showSolution",params:[false,showsolution]}, this.iframeContentDomain);
			}
			
			me.ShowHideSolution();
		}
	}
	ShowHideSolution(){
		
		if(this.showSolution){
			//$("#displaySolnStudent").html(btn_hidesolution);
		}else{
			//$("#displaySolnStudent").html(btn_viewsolution);
		}
	}
	setScrollElement(target){
		var me=this;
		setTimeout(function(){
			//this.prassoView.scrollToId(target);
			me.prassoView.postMessage({name:"scrollToId",params:[target]}, this.iframeContentDomain);
		}, 500);
	}
	modalCloseEvent(){
		try{
			window.removeEventListener('message', this.handleMessage, false);
		}catch(e){}
		
		try{
			this.enableQuestionTrackTimer = false;
			clearInterval(this.intervalId);
		}catch(e){}
		try{
			
			this.timeSpentAction = "Close";
			if(this.isVisible($(".quesDispContainer"))==true){
				this.trackTimeSpentInQuestion();
			}
		}catch(e){}
		
		this.trackTestClose();
		
		try{
			var trackObj = {
				"test_id": this.props.topicInfoObj.testDetails.id,
				"submitted": false
			}	
			
			if(this.state.testMode != 1){
				if(this.state.testCompleted){
					trackObj.submitted = true;
				}else{
					trackObj.submitted = false;
				}
			}

			this.initiateTrack("test_closed",trackObj);
		}catch(e){}
	}
	trackTestClose(){
		var me = this;
		try{
			var postParams = {
				"trackingDefId" : 4,
				"testId" : this.props.topicInfoObj.testDetails.id,
				"endTime" : new Date().getTime()				
			}
			
			
			var callBackSuccess = function(response){
			}

			var callBackFailure = function(error){
				console.log("Error in TRACK_TEST_CLOSED");
			}

			new HmAjax(this.getUrlFor("TRACK_TEST_CLOSED"),postParams).post(callBackSuccess,callBackFailure);
		}catch(e){}
		
	}
	isVisible(element) {
		var element = $(element);
		if (element.length > 0 && element.css('visibility') !== 'hidden' && element.css('display') !== 'none') {
			return true;
		} else {
			return false;
		}
	}
	trackTimeSpentInQuestion(){
		if(this.questionAnswerStartTime == null){
			return;
		}

		try{
			var endTime = new Date().getTime();
			this.questionAnswerElapsedTime = (endTime - this.questionAnswerStartTime);
			var postParams = {
				"trackingDefId" : 3,
				"testId" :  this.props.topicInfoObj.testDetails.id,
				"questionId" : this.currTestQuestionId,
				"snippetId" : this.currentSnippetId,
				"currQuestAtt" : this.state.currentAttempt,
				"sourceId" : this.state.questionObj.questionSource,
				"timeSpent" : this.questionAnswerElapsedTime,
				"startTime" : this.questionAnswerStartTime,
				"endTime" : endTime,
				"action" : this.timeSpentAction
			}
			
			var me = this;
			var callBackSuccess = function(response){
			}

			var callBackFailure = function(error){
				console.log("Error in TRACK_QUESTION_TIMESPENT");
			}

			new HmAjax(this.getUrlFor("TRACK_QUESTION_TIMESPENT"),postParams).post(callBackSuccess,callBackFailure);
			
			this.questionAnswerStartTime = new Date().getTime();
			this.enableQuestionTrackTimer = false;
		}
		catch(e){}
	}
	getQuestion(){
		this.isEvaluationGoing = false;
	   // this.setState({paginationDisabled:true,questionRendered:false});
	   this.setState({paginationDisabled:true,questionRendered:false,questionEvaluated:false,currentAttempt:this.currentAttempt,currentQuesNo:this.currentQuestionNo,showSolution:false});
	   var me = this;
	   this.questionAnswerStartTime = null;
	   this.enableQuestionTrackTimer = false;
	   this.currentRating = null;
	   var topicQuesObj = this.props.topicInfoObj.userTest.ques[this.currentQuestionNo-1];
	   var testid = this.props.topicInfoObj.testDetails.id;
	   let getQuestionURL = "";
	   this.allowedAttempts = topicQuesObj.attempts;
	   this.currTestQuestionId  = topicQuesObj.id;
	   this.currentSnippetId = topicQuesObj.qId;
		//console.log("topicQuesObj::",topicQuesObj);
		if (this.allowedAttempts > 0) {
			//$("#totalAttempts").html(this.allowedAttempts.toString());
			if (this.attemptsLeft == -1) {
				this.attemptsLeft = this.allowedAttempts - (this.currentAttempt - 1);
				//$("#attemptsLeft").html(this.attemptsLeft.toString());
			}
		} else {
			//$("#totalAttempts").html("&infin;");
			//$("#attemptsLeft").html("&infin;");
		}
		
		this.attemptBeforeEvaluate = this.state.currentAttempt;
		
		
		var callBackSuccess = function(response){	

			let dataJsonList = response;
			let dataQuestion = dataJsonList;		
			if(me.state.testMode == 1){
				dataQuestion = response.questionContainer;
			}
			me.setState({questionObj:dataQuestion});
			//console.log(dataJsonList.answer);
			me.prassoView.postMessage({name:"loadQuestion",params:[dataQuestion.question, dataJsonList.answer]}, me.iframeContentDomain);
			
			me.container.scrollTop = 0;
			me.updateProgress();
			me.checkImageLoaded();
		}

		var callBackFailure = function(response){
			this.questionLoadTime = null;
			me.setState({paginationDisabled:false});
			console.log("GET_QUESTION Error : ", response);
			//me.setState({  modalContent:me.setTestScreen() });
		}
		
		
		if(this.state.testMode == 1){
			getQuestionURL = this.getUrlFor("GET_QUESTION_TEST");
		}else{
			getQuestionURL = this.getUrlFor("GET_QUESTION");
		}
		new HmAjax(getQuestionURL+"?snippetId="+topicQuesObj.qId+"&questionId="+topicQuesObj.id+"&attempt="+this.state.currentAttempt+"&source="+topicQuesObj.source+"&testId="+testid).get(callBackSuccess,callBackFailure);
		
		if(this.questionLoadTime == null){
			this.questionLoadTime = new Date().getTime();
		}
		this.trackingQuestionObj = {
			"test_id": testid,
			"snippet_id": this.currentSnippetId,
			"question_source":topicQuesObj.source,
			"attempt_no": this.state.currentAttempt
		}
	}
	submitClick(forceSubmit){
		this.forceSubmit = (forceSubmit === true) ? true : false;
		var me = this;
		this.isSubmitTriggered = true;
		this.timeSpentAction = "Submit";
		var unattemptedQuestionCount = this.state.totalQuestions - Object.keys(this.submittedQnMap).length;
		console.log("unattemptedQuestionCount="+unattemptedQuestionCount);
	   /*if(unattemptedQuestionCount > 0){
			this.triggerGetUserAnswer(); 	
		}else{
			this.showSubmitConfirm();
		}	*/
		this.triggerGetUserAnswer(); 	
	}
	submitPractice(){
		this.isSubmitTriggered = false;
		this.evalAndNavigate = false;
		this.evalAndSubmit = true;

		this.completeTest();

		return;
		/**
		*IMPORTANT: Following block may have been written for a purpose which is unknown for the present devs.
		* Hence, commenting the code below. Should there be any unwanted scenarios, please check before uncommenting the following code.
		*/
	/**	var testId = this.props.topicInfoObj.testDetails.id;
		let testType = this.props.topicInfoObj.testDetails.type;

		var trackObj = {
			"test_id": testId,
			"submitted": true
		}		
		this.storeTrackEvent("test_closed", trackObj);

		this.timeSpentAction = "Submit";
		this.trackTimeSpentInQuestion();
		this.trackTestClose();

		let redirectUrl = "/scorecard/"+testId;
		if(testType === 5 || testType === 6){
			//window.location.href="/800";
			redirectUrl = "/report";
		}

		setTimeout(function(){
			window.location.href = redirectUrl;
		},500)
*/
	}
	triggerGetUserAnswer(){
		this.evalAndNavigate = false;
		this.evalAndSubmit = false;
		this.evalAns();
	}
	showSubmitConfirm(){
		var me = this;
		var unattemptedQuestionCount = this.state.totalQuestions - Object.keys(this.submittedQnMap).length;
		var msg = "";
		if(typeof me.props.resumeTimer === "function"){
			me.props.resumeTimer();
		}
		if(unattemptedQuestionCount > 0){
		   //msg = 'You have not attempted '+unattemptedQuestionCount+' question(s).';
		   msg = this.rb("test.confirm.unattempted",[unattemptedQuestionCount]);
		}else{
			msg = this.rb("test.confirm.allanswered");
		}
		confirmAlert({
			title: this.rb("test.confirm.wanttosubmit"),
			message: msg,
			buttons: [
			{
				label: this.rb("alert.ok"),
				onClick: () => {
					this.isSubmitTriggered = false;
					this.evalAndNavigate = false;
					this.evalAndSubmit = true;
				//me.evalAns();
				me.completeTest();
			}
		},
		{
			label: this.rb("alert.cancel"),
			onClick: () => {
				this.isSubmitTriggered = false;


			}
		}
		]
	});	  
	}
	showAutoSubmitConfirm(callback, response){
		var me = this;
		var unattemptedQuestionCount = this.state.totalQuestions - Object.keys(this.submittedQnMap).length;
		var msg = "";
		if(unattemptedQuestionCount > 0){
			//msg = 'You have not attempted '+unattemptedQuestionCount+' question(s).';
			msg = this.rb("test.confirm.unattempted",[unattemptedQuestionCount]);
		}else{
			msg = this.rb("test.confirm.allanswered");
		}
		confirmAlert({
			title: this.rb("test.confirm.autosubmit"),
			message: msg,
			buttons: [
			{
				label: this.rb("alert.autosubmit.ok"),
				onClick: () => {
					if(typeof callback === "function"){
						callback.apply(this,[response]);
					}
			/* 	this.isSubmitTriggered = false;
				this.evalAndNavigate = false;
				this.evalAndSubmit = true;
				//me.evalAns();
				me.completeTest(); */
			}
		}
		],
		closeOnClickOutside : false
	});	  
	}
	completeTest(isScoreCard=false){	  
		var me = this;

		var testId = me.props.topicInfoObj.testDetails.id;
		var testType = me.props.topicInfoObj.testDetails.type;

		let finalCallBack = function(response){
			me.prassoView.postMessage({name:"disableInput"}, me.iframeContentDomain);


			let redirectUrlByType = (window.test_type_submit_route) ? window.test_type_submit_route[testType] : null;

			if(redirectUrlByType){
				window.location.href=redirectUrlByType;
			}else if(me.state.testMode == 1 || isScoreCard || !redirectUrlByType){
				console.log("testId22="+testId)
				var trackObj = {
					"test_id": testId,
					"submitted":true
				}
				me.storeTrackEvent("test_closed", trackObj);
				me.trackTestClose(); 

				window.location.href="/scorecard/"+testId;

			}
			if(typeof me.props.closeTimer === "function"){
				me.props.closeTimer();
			}
		}

		var callBackSuccess = function(response){	
			if(me.forceSubmit){
				me.showAutoSubmitConfirm(finalCallBack, response);
			}else{
				finalCallBack(response); 
			}			
		}

		var callBackFailure = function(response){	
			me.isAjaxSubmitTriggered = false;
			console.log("SUBMIT_TEST Error : ", response);
			//me.setState({  modalContent:me.setTestScreen() });
		}		
		
		var postParams={			
			"testId":testId,
			"revisionTestId":this.props.revisiontestid,
			"topicSubtopicMapId":this.props.topicsubtopicId
		}

		if(typeof me.props.callbackParent === "function"){
			postParams["time"] = window.btoa(me.props.callbackParent());
			//console.log("submit test ",this.props.callbackParent());
		}

		if(!this.isAjaxSubmitTriggered){
			this.isAjaxSubmitTriggered = true;
			new HmAjax(this.getUrlFor("SUBMIT_TEST"),postParams).put(callBackSuccess,callBackFailure);
		}		
		
	}
	updateProgress() {	
		var percentComplete = 0 ;
		if(this.state.testMode == 1){
			percentComplete = Math.round(((Object.keys(this.submittedQnMap).length) / this.state.totalQuestions) * 100);
		}else{
			percentComplete = Math.round(((this.currentQuestionNo-1) / this.totalNoQuestions) * 100);
		}
		
		this.setState({percentageComplete:percentComplete});		
	}
	EvaluateClick(){
		if(this.isEvaluationGoing == false){
			this.evalAndNavigate = false;
			this.evalAndSubmit = false;	
			this.isEvaluationGoing = true;
			this.timeSpentAction = "Check";
			this.evalAns();
		}
	}
	NextClick(){
		this.getQuestion();
		this.timeSpentAction = "Next";
		this.trackTimeSpentInQuestion();
	}
	viewHideSolutionClick(){
		this.showSolution = !this.showSolution;		
		this.chooseShowSolution(this.correctAns,this.showSolution,this.solutionResults);
		this.setState({showSolution:this.showSolution});
		if(this.showSolution){
			this.setScrollElement("solution-display");
		}else{
			this.setScrollElement("question-display");			
		}
		
		this.trackShowHideSolution(this.showSolution);
		this.checkImageLoaded();
	}
	trackShowHideSolution(showSol){
		var myaction = "";

		if(showSol == true){
			myaction = "Open";
		}else{
			myaction = "Close";			
		}
		var postParams = {
			trackingDefId: 1,
			testId : this.props.topicInfoObj.testDetails.id,
			questionId : this.currTestQuestionId,
			snippetId : this.currentSnippetId,			
			currQuestAtt : this.state.currentAttempt,
			sourceId : this.state.questionObj.questionSource,
			action : myaction
		}
		
		var me = this;
		var callBackSuccess = function(response){
			
		}

		var callBackFailure = function(error){
			console.log("Error in TRACK_SOLUTION");
		}

		new HmAjax(this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);
		
		try{
			var trackObj = {
				"test_id": this.props.topicInfoObj.testDetails.id,
				"snippet_id": this.currentSnippetId,
				"question_source":this.state.questionObj.questionSource,
				"item_type": this.getTracker().enums.viewedItemType.solution,
				"hidden": !showSol
			}
			this.initiateTrack("item_viewed",trackObj);
		}catch(e){
		}
	}
	getStatusText(){
		if(this.props.topicInfoObj.userTest.status == "IN_PROGRESS"){
			return this.rb("home.continue");
		}else{
			return "Start Practice";
		}
	}
	getStatusActionText(){	  


		if(this.props.subtopic){
			if(this.props.subtopic.status == "IN_PROGRESS"){
				if(this.props.subtopic.testStatus == "COMPLETED" && this.props.subtopic.reqTestStatus != "COMPLETED"){
					if(this.props.subtopic.reqTestStatus == "IN_PROGRESS"){
						return this.rb("home.resume");	
					}else{
						return this.rb("home.start");
					}
				}

				return this.rb("home.resume");			
			}else if(this.props.subtopic.status == "COMPLETED"){
				return "";
				
			}else{
				return this.rb("home.start");
			}
		}else if(this.props.studentStatus){
			if (this.props.studentStatus === "IN_PROGRESS") {
				return this.rb("home.resume");
			} else {
				return this.rb("home.start");
			}
		}
	}
	getviewhideText(){
		if(this.state.showSolution){
			return this.rb("test.hidesolution");
		}else{
			return this.rb("test.viewsolution");
		}
	}
	renderBottomSection(){
		console.log("this.props.topicInfoObj:::",this.props.topicInfoObj);
		return(
			<MuiThemeProvider>
			<div className="col-12 row nopadding">				

			{(() => {
				if(this.state.testMode == 1){		
					return(
						<div className="col-12 row nopadding">	
						<div className="col-12 col-sm-12 col-md-9 text-center nopadding">
						<Pagination
						currentPage={this.state.currentQuesNo}
						totalPages={this.state.pageTotal}
						boundaryPagesRange={1}
						siblingPagesRange={1}
						hidePreviousAndNextPageLinks={false}
						hideFirstAndLastPageLinks={false}
						hideEllipsis={false}
						onChange={this.onPageChange}
						disabled={this.state.paginationDisabled}
						/>
						</div>

						<div className="col-12 col-sm-12 col-md-3 submittestbtndiv">
						<button type="button" className="btn btn-primary mediumBtn float-right" disabled={!this.state.questionRendered} onClick={this.submitClick} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicInfoObj.testDetails.title+" - "+this.props.topicInfoObj.testDetails.topics.split("- Customized Practice").join("")+" - "+(this.props.topicInfoObj.testDetails.mode == 1 ? "PT" : "CP")+" - "+"Submit Test"}>
						{this.rb("test.submittest")}
						</button>
						</div>
						</div>
						)
				}else{
					if(this.state.questionEvaluated == false){
						return(
							<div className="col-12 row">	
							<div className="col-12 col-sm-12">											
							<button type="button" className="btn btn-primary mediumBtn float-right" disabled={!this.state.questionRendered && !this.isEvaluationGoing} onClick={this.EvaluateClick} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicInfoObj.testDetails.title+" - "+this.props.topicInfoObj.testDetails.topics.split("- Customized Practice").join("")+" - "+("CP")+" - "+this.getStatusActionText()+" - "+this.getStatusText()+" - "+"Check"}>
							{this.rb("test.check")}
							</button>	
							</div>										 
							</div>
							)
						}else{
							return(
							<div className="col-12 row">	
							<div className="col-12 col-sm-12 nopadding">		
							{(() => {
								if(this.state.testCompleted){
									return(
									<button type="button" className="btn btn-primary mediumBtn float-right mb-20 ml-10" disabled={!this.state.questionRendered} onClick={this.submitPractice} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicInfoObj.testDetails.title+" - "+this.props.topicInfoObj.testDetails.topics.split("- Customized Practice").join("")+" - "+("CP")+" - "+this.getStatusActionText()+" - "+this.getStatusText()+" - "+"Submit"}>
									{this.rb("test.submit")}
									</button>	
									);
								} else{
									return(
									<button type="button" className="btn btn-primary mediumBtn float-right mb-20 ml-10" disabled={!this.state.questionRendered} onClick={this.NextClick} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicInfoObj.testDetails.title+" - "+this.props.topicInfoObj.testDetails.topics.split("- Customized Practice").join("")+" - "+("CP")+" - "+this.getStatusActionText()+" - "+this.getStatusText()+" - "+"Next"}>
									{this.rb("test.next")}
									</button>	
									);
								}											 				
							})()}

							<button type="button" className="btn btn-primary mediumBtn float-right" disabled={!this.state.questionRendered} onClick={this.viewHideSolutionClick} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicInfoObj.testDetails.title+" - "+this.props.topicInfoObj.testDetails.topics.split("- Customized Practice").join("")+" - "+("CP")+" - "+this.getStatusActionText()+" - "+this.getStatusText()+" - "+this.getviewhideText()}>
							{(() => {
								if(this.state.showSolution){return (<div>{this.rb("test.hidesolution")}</div>)} else{return (<div>{this.rb("test.viewsolution")}</div>)}											 				
							})()}											 			
						</button>
						</div>										 
						</div>
						)
					}

				}
			})()}

			</div>
			</MuiThemeProvider>
			);
		}
		updatePercentageDisplay(){


			return(
			<div className="percentageDisp float-right">
			{(() => {
				if(this.state.testMode == 1){		
					return(
					<h5>{this.state.percentageComplete}% {this.rb("test.complete")} </h5>
					)
				}else{						
					return(
					<h5>{this.state.percentageComplete}% {this.rb("test.complete")} &nbsp; | &nbsp;{this.rb("test.attemptsleft")}: {(this.attemptsLeft<0)?0:this.attemptsLeft} </h5>
					)
				}
			})()}
			</div>
			);
		}
		likeFn(event){
			if($(event.currentTarget).hasClass("selected")){
				return false;
			}
			const ratingIcons = document.querySelectorAll('.ratingIcon');
			ratingIcons.forEach(rating => {
				rating.classList.remove('selected');
			})
			event.currentTarget.classList.add("selected");

			var postParams = {
				trackingDefId: 2,
				testId : this.props.topicInfoObj.testDetails.id,
				questionId : this.currTestQuestionId,
				snippetId : this.currentSnippetId,
				rating : parseInt($(event.currentTarget).attr("data-id")), 
				currQuestAtt : this.state.currentAttempt,
				sourceId : this.state.questionObj.questionSource,
				action : "submit"
			}
			this.currentRating = parseInt($(event.currentTarget).attr("data-id"));
			var me = this;
			var callBackSuccess = function(response){
				$(".likebox").attr("data-myrating",this.currentRating);
			}

			var callBackFailure = function(error){
				console.log("Error in TRACK_SOLUTION");
			}

			new HmAjax(this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);


			try{
				var trackObj = {
					"test_id": this.props.topicInfoObj.testDetails.id,
					"snippet_id": this.currentSnippetId,
					"question_source":this.state.questionObj.questionSource,
					"attempt_no": this.attemptBeforeEvaluate,
					"helpful": parseInt($(event.currentTarget).attr("data-id")) === 2,
					"source":this.getTracker().enums.itemRatedSource.test
				}
				this.initiateTrack("solution_rated",trackObj);
			}catch(e){
			}


		}
		setRatingSelected(id){
			if(this.currentRating != null){
				if(this.currentRating == id){
					return "selected";
				}
			}
		}
		renderRatingContainer() {
			if(this.state.showSolution){
				return (
				<div className="likebox" data-myrating="0">
				<p>{this.rb("rating.title")}</p>
				<div className="btngp">
				<span className={"ratingIcon "+this.setRatingSelected(2)} data-id="2" onClick={this.likeFn.bind(this)}><i className="material-icons">thumb_up</i></span>
				<span className={"ratingIcon "+this.setRatingSelected(1)} data-id="1" onClick={this.likeFn.bind(this)}><i className="material-icons">thumb_down</i></span>
				</div>
				</div>
				)
			}
		}
		checkImageLoaded(){	
			try{
				$('img').unbind("error");
				$('img').error(function(){		
					var me = this;
					var timeDelay = 5000;

					if(!$(me).attr('imageReloadCount')){
						$(me).attr('imageReloadCount',1);
					}

					timeDelay = timeDelay * parseInt($(me).attr('imageReloadCount'));			

					setTimeout(function()
					{ 				
						if(!$(me).attr('imageReloadCount')){
							$(me).attr('imageReloadCount',1);
						}else{
							$(me).attr('imageReloadCount',parseInt($(me).attr('imageReloadCount'))+1);
						}

						if($(me).attr('imageReloadCount')<=4){
							//console.log("timeDelay::",timeDelay);
							$(me).attr('src',$(me).attr('src'));
						}

						if(console){
							console.log("image not loaded :"+$(me).attr('src'));			
						}

					}, timeDelay);		

				}).load(function(){
					//console.log("loaded successfully...");
				});
			}
			catch(e){

			}

		}
		render = () => {
			let me = this;
			return(				
			<div className="row modalBase testTakingScreen">

			<div className="col-12 quesDispContainer">
			<div className="clearfix">
			<div className="quesNumDisp float-left"><div> Q{this.state.currentQuesNo}</div></div>
			{this.updatePercentageDisplay()}
			<div className="float-right"><CircularProgressbar percentage={ this.state.percentageComplete}  styles={{
				path: { stroke: 'rgba(62, 152, 199, ${this.state.percentageComplete / 100})' },
			}}/></div>
			</div>
			<Iframe url={this.getUrlFor("IFRAME_DOMAIN") + "/prassoapp/20171102/"}
			ref = {e => {
				me.container = e;
			}}
			position="relative"
			id="quesIframe"
			width="100%"				            
			className="quesIframe"
			height="100%"				            
			styles={{height: "63vh"}}					
			allowFullScreen/>
			</div>


			{this.renderRatingContainer()}

			{this.renderBottomSection()}					
			</div>
			);
		}
	}

	export default GetTest;



// WEBPACK FOOTER //
// ./src/views/plp/GetTest.js